import { useCallback, useEffect, useState } from "react";
import { ChatSupport } from "../../../entities/chat-support.entity";
import { useChatSupport } from "../../../context/chat-support/chat-support.context";
import { RepoistoryFilter } from "../../../types/util.types";
import { Spinner } from "../../shared/atoms/spinner";
import { SortIconBtn } from "../../shared/atoms/sort-icon.btn";
import { ChatStatusFilter } from "../../../types/chat-support/chat-support.type";
import { FaChevronDown } from "react-icons/fa";

export const ChatNavHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState<ChatStatusFilter>("All");
  const [totalDocsCount, setTotalDocsCount] = useState<number>();
  const {
    actions,
    states: {
      chats: { isfetching, setIsFetching },
      filter: { filter, updateFilter },
    },
  } = useChatSupport();

  const fetchChatData = useCallback(async () => {
    const res = await actions.getChatSummaryies(filter, status);
    if (!res) return;
    setTotalDocsCount(res.totalDocsCount);
  }, [actions, filter, status]);
  useEffect(() => {
    if (isfetching) {
      fetchChatData();
    }
  }, [isfetching, fetchChatData]);
  const handleFilterChange = (newStatus?: ChatStatusFilter, newFilter?: RepoistoryFilter<ChatSupport>) => {
    setIsFetching(true);
    if (newStatus) {
      setStatus(newStatus);
    }

    const lastFilter = { ...filter, ...newFilter, status: newStatus ?? status };

    updateFilter({ ...lastFilter });
  };

  return (
    <div className=" flex gap-2 items-center  shadow   ">
      <div className="relative inline-block text-left">
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          {status}
          {!isfetching && (
            <span className="bg-brand-light_blue/20 rounded-full text-sm ml-2 px-3">{totalDocsCount}</span>
          )}
          <FaChevronDown className="ml-2 h-4 w-4" />
        </button>

        {isOpen && (
          <div className="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="py-1">
              {["All", "Open", "Closed"].map((label) => (
                <button
                  key={label}
                  onClick={() => {
                    handleFilterChange(label as ChatStatusFilter);
                    setIsOpen(false);
                  }}
                  className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {isfetching && <Spinner />}

      <div className=" ms-auto me-1 hover:bg-slate-200 size-8 flex_center rounded-lg ">
        <SortIconBtn
          className=" text-2xl cursor-pointer "
          sort={filter.orderBy![1]}
          onClick={(newSort) =>
            handleFilterChange(status, {
              orderBy: ["createdAt", newSort],
            })
          }
        />
      </div>
    </div>
  );
};
